import { useTranslation } from "react-i18next";
import { useState } from "react";
import React from "react";
import { useSelector } from 'react-redux';
import IDynamicFormRow from '../../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow';
import DynamicForm from "../../yoello-lib/modules/dynamicForms/DynamicForms";
import EColourPanel from "../../interfaces/EColourPanel";
import FormTitle from "../../yoello-lib/modules/dynamicForms/FormComponents/FormTitle";
import ListLoading from "../util/Loading";
import { IReduxAppState } from "../../reducers";
import { FormPermissions } from "../../Permissions";

export interface IProfileFormProps<T> {
    formData: T;
    onFormSubmit: (data: T) => Promise<any>;
    transformFunction?: (data: any) => any;
    title: string;
    formRows: IDynamicFormRow[];
    formKey: string;
    subTitle?: string;
    formButtonText?: string;
    leftButtonCustomClassName?: string;
    rightButtonCustomClassName?: string;
    resolver?: any;
    isDisabled?: boolean;
    onFailedInteraction?: Function
}

function ProfileForm<T>({ formData, isDisabled, onFailedInteraction, onFormSubmit, formKey, transformFunction, formRows, formButtonText, title, subTitle, leftButtonCustomClassName, rightButtonCustomClassName, resolver }: IProfileFormProps<T>) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const subscription = useSelector((state: IReduxAppState) => state.subscription);
    const handleSubmit = (data: any) => {
        const newFormData: Record<string, T> = {};
        /**
        * We're ensuring only correct fields are edited 
         * Sometimes left over keys can linger 
        */
        for (const key in data) {
            const index = formRows.findIndex((row) => row.keyName === key);
            if (index > -1) {
                newFormData[key] = data[key];
            }
        }
        let transformData = newFormData as unknown as T;
        if (transformFunction) {
            transformData = transformFunction(newFormData);
        }
        setIsLoading(true);
        onFormSubmit(transformData).finally(() => {
            setIsLoading(false);
        });
    };
    return <div className="ProfileForm dialog">
        {title && <FormTitle title={t(title)} subtitle={subTitle ? t(subTitle) : undefined} />}
        {isLoading ? <ListLoading /> :
            <DynamicForm formData={formData} formRows={formRows}
                formKeyName={formKey} onHandleSubmit={handleSubmit}
                useFormOptions={{ reValidateMode: 'onChange', mode: 'onChange', resolver: resolver }}
                disabledFields={FormPermissions["profile"]}
                subscriptionKey={subscription}
                disableAll={isDisabled}
                disableAllInteraction={onFailedInteraction}
                formButtons={{
                    leftButton: formButtonText ? { label: t(formButtonText), type: "submit", color: EColourPanel.PRIMARY, disabled: isLoading || isDisabled } : undefined,
                    rightButtonCustomClassName: rightButtonCustomClassName,
                    leftButtonCustomClassName: leftButtonCustomClassName
                }} />
        }
    </div>;
}

export default ProfileForm;
